import { Timestamp } from 'firebase/firestore';
import { addBalanceInstruction } from '../sp-firebase/balanceFlowFB';
import { Account } from '../sp-types/accountTypes';
import { BalanceSuggestedInstructions } from '../sp-types/buyingInstructionsType';
import { IFutureOrder } from '../sp-types/FutureOrderType';
import { IInventoryReportType } from '../sp-types/InventoryReportType';
import { IInventory } from '../sp-types/InventoryType';
import { Material } from '../sp-types/materialType';
import { Product } from '../sp-types/productType';

export const newYossiAccountToCreate: Account = {
  companyDetails: {
    contact: 'Yoss',
    name: 'Brok Yoss',
    registrationNo: 'Yoss',
    signatoryRights: 'contracts/ZmPJxmiRkkQKv8DKd1WvK8rYL282/companySignatoryRights/Screenshot 2024-01-31 173156.png',
    signatureAuthorized: true,
    tradingAddress: 'Yoss',
    vat: 'Yoss',
  },
  contactDetails: {
    email: 'yossi9980@gmail.com',
    name: 'Yossi GG',
    phoneNumber: 'ASDASDSADA',
  },
  brokerDetails: {
    email: 'qweqwewq123123',
    name: 'qweqw',
    phoneNumber: 'qweqwe',
  },
  bankDetails: {
    accountName: '123',
    accountNo: '123',
    authorizeSpotlock: true,
    bicswift: '23',
    confirmation: 'contracts/ZmPJxmiRkkQKv8DKd1WvK8rYL282/bankConfiramtion/Screenshot 2024-02-01 165707.png',
    iban: '123',
    name: '123',
    sortCode: '123',
  },
  collateralDetails: {
    allocatedCollateral: 0,
    availableCollateral: 0,
    confirmationDoc: [],
    immediateConfirmation: 0,
    marginCall: 0,
    newCollateralAmount: 0,
  },
  country: 'UK',
  materialsToAccount: [
    {
      materialId: 'CSRRc1',
      RiskTolerance: {
        dangerAreaMinus: { start: -2_000_000, end: -1_000_000 },
        dangerAreaPlus: { start: 1_000_000, end: 2_000_000 },
        stableArea: { start: -500_000, end: 500_000 },
      },
      RoutePriority: [],
    },
    {
      materialId: 'CMAL3',
      RiskTolerance: {
        dangerAreaMinus: { start: -2_000_000, end: -1_000_000 },
        dangerAreaPlus: { start: 1_000_000, end: 2_000_000 },
        stableArea: { start: -500_000, end: 500_000 },
      },
      RoutePriority: [],
    },
    {
      materialId: 'HRCc1',
      RiskTolerance: {
        dangerAreaMinus: { start: -2_000_000, end: -1_000_000 },
        dangerAreaPlus: { start: 1_000_000, end: 2_000_000 },
        stableArea: { start: -500_000, end: 500_000 },
      },
      RoutePriority: [],
    },
    {
      materialId: 'BUSc1',
      RiskTolerance: {
        dangerAreaMinus: { start: -2_000_000, end: -1_000_000 },
        dangerAreaPlus: { start: 1_000_000, end: 2_000_000 },
        stableArea: { start: -500_000, end: 500_000 },
      },
      RoutePriority: [],
    },
    {
      materialId: 'CSSCc1',
      RiskTolerance: {
        dangerAreaMinus: { start: -2_000_000, end: -1_000_000 },
        dangerAreaPlus: { start: 1_000_000, end: 2_000_000 },
        stableArea: { start: -500_000, end: 500_000 },
      },
      RoutePriority: [],
    },
    {
      materialId: 'SRBc1',
      RiskTolerance: {
        dangerAreaMinus: { start: -2_000_000, end: -1_000_000 },
        dangerAreaPlus: { start: 1_000_000, end: 2_000_000 },
        stableArea: { start: -500_000, end: 500_000 },
      },
      RoutePriority: [],
    },
    {
      materialId: 'CMCU3',
      RiskTolerance: {
        dangerAreaMinus: { start: -2_000_000, end: -1_000_000 },
        dangerAreaPlus: { start: 1_000_000, end: 2_000_000 },
        stableArea: { start: -500_000, end: 500_000 },
      },
      RoutePriority: [],
    },
    {
      materialId: 'CMZN3',
      RiskTolerance: {
        dangerAreaMinus: { start: -2_000_000, end: -1_000_000 },
        dangerAreaPlus: { start: 1_000_000, end: 2_000_000 },
        stableArea: { start: -500_000, end: 500_000 },
      },
      RoutePriority: [],
    },
  ],
  creator: 'ZmPJxmiRkkQKv8DKd1WvK8rYL282',
  status: 'active',
  //products: [],
  AdjustmentsInfo: {
    materialAdjustmentsOptions: ['Last qtr avg.', 'Trailing month'],
    productAdjustmentOptions: ['Last qtr avg.', 'Trailing month'],
    productPriceIndexes: ['interest', 'Consumer price index', 'HRC index'],
    // Add properties as needed
  },
  riskPercents: { volatility: '30%', riskBackTesting: [{ key: '35%', value: 10 }] },
};

export const materialsToAdd: Material[] = [
  {
    currentPrice: 100,
    id: 'CSRRc1',
    name: 'LME Rebar',
    priceDate: Timestamp.now(),
    priceIndex: 'LSEG',
    volatility: '25%',
    riskBackTesting: [
      { key: '10%', value: 35 },
      { key: '15%', value: 25 },
      { key: '25%', value: 15 },
    ],
  },
  {
    currentPrice: 100,
    id: 'CMAL3',
    name: 'LME Aluminium',
    priceDate: Timestamp.now(),
    priceIndex: 'LSEG',
    volatility: '25%',
    riskBackTesting: [
      { key: '10%', value: 35 },
      { key: '15%', value: 25 },
      { key: '25%', value: 15 },
    ],
  },
  {
    currentPrice: 100,
    id: 'HRCc1',
    name: 'HRC Steel',
    priceDate: Timestamp.now(),
    priceIndex: 'LSEG',
    volatility: '25%',
    riskBackTesting: [
      { key: '10%', value: 35 },
      { key: '15%', value: 25 },
      { key: '25%', value: 15 },
    ],
  },
  {
    currentPrice: 100,
    id: 'BUSc1',
    name: 'Busheling Scrap',
    priceDate: Timestamp.now(),
    priceIndex: 'LSEG',
    volatility: '25%',
    riskBackTesting: [
      { key: '10%', value: 35 },
      { key: '15%', value: 25 },
      { key: '25%', value: 15 },
    ],
  },
  {
    currentPrice: 100,
    id: 'CSSCc1',
    name: 'LME Scrap',
    priceDate: Timestamp.now(),
    priceIndex: 'LSEG',
    volatility: '25%',
    riskBackTesting: [
      { key: '10%', value: 35 },
      { key: '15%', value: 25 },
      { key: '25%', value: 15 },
    ],
  },
  {
    currentPrice: 100,
    id: 'SRBc1',
    name: 'SHFE Rebar',
    priceDate: Timestamp.now(),
    priceIndex: 'LSEG',
    volatility: '25%',
    riskBackTesting: [
      { key: '10%', value: 35 },
      { key: '15%', value: 25 },
      { key: '25%', value: 15 },
    ],
  },
  {
    currentPrice: 100,
    id: 'CMCU3',
    name: 'LME Copper',
    priceDate: Timestamp.now(),
    priceIndex: 'LSEG',
    volatility: '25%',
    riskBackTesting: [
      { key: '10%', value: 35 },
      { key: '15%', value: 25 },
      { key: '25%', value: 15 },
    ],
  },
  {
    currentPrice: 100,
    id: 'CMZN3',
    name: 'LME Zinc',
    priceDate: Timestamp.now(),
    priceIndex: 'LSEG',
    volatility: '25%',
    riskBackTesting: [
      { key: '10%', value: 35 },
      { key: '15%', value: 25 },
      { key: '25%', value: 15 },
    ],
  },
];

const routeId = 'HRC';
const routeQuantity = 2;
const positionType = 'long' as const;
const props = { action: 'buy' as const, routeId, routeQuantity, positionType };
export const addHRC30MInstructions = () => {
  const instructions: BalanceSuggestedInstructions = {
    materialId: 'HRCc1',
    accountId: 'useCase3',
    exposureRange: { min: 20_000_000, max: 40_000_000 },
    buyingInstructions: {
      HRCG24: { ...props, numberOfContracts: 210, instrumentId: 'HRCG24' },
      HRCH24: { instrumentId: 'HRCH24', ...props, numberOfContracts: 210 },
      HRCJ24: { ...props, numberOfContracts: 210, instrumentId: 'HRCJ24' },
      HRCK24: { ...props, numberOfContracts: 210, instrumentId: 'HRCK24' },
      HRCM24: { ...props, numberOfContracts: 210, instrumentId: 'HRCM24' },
      HRCN24: { ...props, numberOfContracts: 210, instrumentId: 'HRCN24' },
      HRCQ24: { ...props, numberOfContracts: 210, instrumentId: 'HRCQ24' },
      HRCU24: { ...props, numberOfContracts: 210, instrumentId: 'HRCU24' },
      HRCV24: { ...props, numberOfContracts: 210, instrumentId: 'HRCV24' },
      HRCX24: { ...props, numberOfContracts: 210, instrumentId: 'HRCX24' },
    },
  };

  addBalanceInstruction(instructions, 'firstTryUC3');
};

export const addHRC15MInstructions = () => {
  const instructions: BalanceSuggestedInstructions = {
    materialId: 'HRCc1',
    accountId: 'useCase1',
    exposureRange: { min: -20_000_000, max: -10_000_000 },
    buyingInstructions: {
      HRCG24: { ...props, numberOfContracts: 100, instrumentId: 'HRCG24' },
      HRCH24: { instrumentId: 'HRCH24', ...props, numberOfContracts: 100 },
      HRCJ24: { ...props, numberOfContracts: 100, instrumentId: 'HRCJ24' },
      HRCK24: { ...props, numberOfContracts: 100, instrumentId: 'HRCK24' },
      HRCM24: { ...props, numberOfContracts: 100, instrumentId: 'HRCM24' },
      HRCN24: { ...props, numberOfContracts: 100, instrumentId: 'HRCN24' },
      HRCQ24: { ...props, numberOfContracts: 100, instrumentId: 'HRCQ24' },
      HRCU24: { ...props, numberOfContracts: 100, instrumentId: 'HRCU24' },
      HRCV24: { ...props, numberOfContracts: 100, instrumentId: 'HRCV24' },
      HRCX24: { ...props, numberOfContracts: 100, instrumentId: 'HRCX24' },
    },
  };

  addBalanceInstruction(instructions, 'balance15MtoUC1');
};

export const addHRC500KInstructions = () => {
  const instructions: BalanceSuggestedInstructions = {
    materialId: 'HRCc1',
    accountId: 'useCase3',
    exposureRange: { min: 0, max: 600_000 },
    buyingInstructions: {
      HRCG24: { ...props, numberOfContracts: 4, instrumentId: 'HRCG24' },
      HRCH24: { instrumentId: 'HRCH24', ...props, numberOfContracts: 4 },
      HRCJ24: { ...props, numberOfContracts: 4, instrumentId: 'HRCJ24' },
      HRCK24: { ...props, numberOfContracts: 4, instrumentId: 'HRCK24' },
      HRCM24: { ...props, numberOfContracts: 4, instrumentId: 'HRCM24' },
      HRCN24: { ...props, numberOfContracts: 4, instrumentId: 'HRCN24' },
      HRCQ24: { ...props, numberOfContracts: 4, instrumentId: 'HRCQ24' },
      HRCU24: { ...props, numberOfContracts: 4, instrumentId: 'HRCU24' },
      HRCV24: { ...props, numberOfContracts: 4, instrumentId: 'HRCV24' },
      HRCX24: { ...props, numberOfContracts: 4, instrumentId: 'HRCX24' },
    },
  };

  addBalanceInstruction(instructions, 'secondTryUC3');
};

export const mockColorFullInventoryData = (accountId: string = 'useCase1'): IInventory => ({
  materialInventory: [
    {
      materialName: 'General',
      futureOrders: [],
      financialPositions: [],
      exposureRisk: 0,
      inventoryProducts: [],
      materialId: 'general',
    },
    {
      financialPositions: [
        {
          date: {
            year: 2024,
            month: 2,
          },
          value: 3091200,
        },
        {
          value: 3091200,
          date: {
            year: 2024,
            month: 3,
          },
        },
        {
          value: 3066000,
          date: {
            year: 2024,
            month: 4,
          },
        },
        {
          value: 3053400,
          date: {
            month: 5,
            year: 2024,
          },
        },
        {
          value: 3036600,
          date: {
            month: 6,
            year: 2024,
          },
        },
        {
          date: {
            year: 2024,
            month: 7,
          },
          value: 3011400,
        },
        {
          date: {
            month: 8,
            year: 2024,
          },
          value: 2986200,
        },
        {
          date: {
            month: 9,
            year: 2024,
          },
          value: 2965200,
        },
        {
          value: 2965200,
          date: {
            month: 10,
            year: 2024,
          },
        },
        {
          value: 2965200,
          date: {
            month: 11,
            year: 2024,
          },
        },
      ],
      materialName: 'Steel HRC',
      exposureRisk: 0,
      futureOrders: [],
      materialId: 'HRCc1',
      inventoryProducts: [],
    },
    {
      futureOrders: [],
      materialName: 'LME Aluminium',
      inventoryProducts: [],
      materialId: 'CMAL3',
      exposureRisk: 0,
      financialPositions: [],
    },
    {
      exposureRisk: 0,
      materialName: 'LME Copper',
      materialId: 'CMCU3',
      financialPositions: [],
      futureOrders: [],
      inventoryProducts: [],
    },
    {
      materialName: 'LME Zinc',
      futureOrders: [],
      exposureRisk: 0,
      materialId: 'CMZN3',
      inventoryProducts: [],
      financialPositions: [],
    },
    {
      materialId: 'CRCc1',
      inventoryProducts: [],
      financialPositions: [],
      exposureRisk: 0,
      materialName: 'Steel HRC',
      futureOrders: [],
    },
  ],
  accountId,
  notifications: [],
  statusFiles: [],
});

export const mockColorFullNewFutureOrderData = (orderId: string = 'colorCaseNewOrder'): IFutureOrder => ({
  orderId,
  updatedAt: Timestamp.now(),
  status: 'completed',
  productId: '1',
  fileUrl: [],
  orderDetails: {
    quantity: 30750000,
    deliveryType: 'Estimate',
    deliveryDates: [
      {
        month: 2,
        year: 2024,
      },
      {
        month: 11,
        year: 2024,
      },
    ],
    productDeliveryCalendar: [
      {
        date: {
          month: 2,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 3,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 4,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 5,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 6,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 7,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 8,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 9,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 10,
          year: 2024,
        },
        value: 3075000,
      },
      {
        date: {
          month: 11,
          year: 2024,
        },
        value: 3075000,
      },
    ],
  },
  clientExposure: {
    CSSCc1: {
      indexOffset: 0,
      basePrice: 550,
      adjustment: 'Trailing month',
      priceIndex: 'Trailing month',
      weightInProduct: 100,
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 1000000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 800000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 650000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 220000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 110000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 140000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 1400000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 1100000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 270000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 430000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 6120000,
        },
      ],
    },
    'HR Steel': {
      indexOffset: 0,
      basePrice: 550,
      adjustment: 'Trailing month',
      priceIndex: 'Trailing month',
      weightInProduct: 100,
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 1200000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 1700000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 900000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 760000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 540000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 430000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 650000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 530000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 430000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 1120000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 870000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 460000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 9590000,
        },
      ],
    },
    'CRC Steel': {
      indexOffset: 0,
      basePrice: 550,
      adjustment: 'Trailing month',
      priceIndex: 'Trailing month',
      weightInProduct: 100,
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 340000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 1870000,
        },
      ],
    },
    'LME Rebar': {
      indexOffset: 0,
      basePrice: 550,
      adjustment: 'Trailing month',
      priceIndex: 'Trailing month',
      weightInProduct: 100,
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 145000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 150000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 170000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 210000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 310000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 320000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 340000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 270000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 250000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 240000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 260000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 320000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 2985000,
        },
      ],
    },
    'Bushelling Scrap': {
      indexOffset: 0,
      basePrice: 550,
      adjustment: 'Trailing month',
      priceIndex: 'Trailing month',
      weightInProduct: 100,
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 130000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 130000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 140000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 140000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 1120000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 1330000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 1250000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 890000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 790000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 630000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 540000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 7210000,
        },
      ],
    },
    'LME Copper': {
      indexOffset: 0,
      basePrice: 550,
      adjustment: 'Trailing month',
      priceIndex: 'Trailing month',
      weightInProduct: 100,
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 140000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 130000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 110000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 0,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 980000,
        },
      ],
    },
    'LME Zink': {
      indexOffset: 0,
      basePrice: 550,
      adjustment: 'Trailing month',
      priceIndex: 'Trailing month',
      weightInProduct: 100,
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 110000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 80000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 150000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 110000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 100000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 90000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 1240000,
        },
      ],
    },
    'LME Aluminium': {
      indexOffset: 0,
      basePrice: 550,
      adjustment: 'Trailing month',
      priceIndex: 'Trailing month',
      weightInProduct: 100,
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 340000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 320000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 360000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 570000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 910000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 3100000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 1150000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 6870000,
        },
      ],
    },
  },
  supplierExposure: [],
  totalExposure: [
    {
      materialId: 'CSSCc1',
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 1000000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 800000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 650000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 220000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 110000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 140000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 1400000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 1100000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 270000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 430000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 6120000,
        },
      ],
      // basePrice: 550,
      // supplyLeadTime: 0,
      // adjustment: '',
      // weightInProduct: 100,
    },
    {
      materialId: 'HRCc1',
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 1200000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 1700000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 900000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 760000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 540000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 430000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 650000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 530000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 430000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 1120000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 870000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 460000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 9590000,
        },
      ],
      // basePrice: 550,
      // supplyLeadTime: 0,
      // adjustment: '',
      // weightInProduct: 100,
    },
    {
      materialId: 'CRCc1',
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 180000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 340000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 1870000,
        },
      ],
    },
    {
      materialId: 'CSRRc1',
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 145000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 150000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 170000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 210000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 310000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 320000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 340000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 270000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 250000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 240000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 260000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 320000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 2985000,
        },
      ],
      // basePrice: 550,
      // supplyLeadTime: 0,
      // adjustment: '',
      // weightInProduct: 100,
    },
    {
      materialId: 'BUSc1',
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 130000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 130000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 140000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 140000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 1120000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 1330000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 1250000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 890000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 790000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 630000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 540000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 7210000,
        },
      ],
      // basePrice: 550,
      // supplyLeadTime: 0,
      // adjustment: '',
      // weightInProduct: 100,
    },
    {
      materialId: 'CMCU3',
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 140000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 130000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 110000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 0,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 980000,
        },
      ],
      // basePrice: 550,
      // supplyLeadTime: 0,
      // adjustment: '',
      // weightInProduct: 100,
    },
    {
      materialId: 'CMZN3',
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 110000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 80000,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 150000,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 110000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 100000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 90000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 90000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 1240000,
        },
      ],
      // basePrice: 550,
      // supplyLeadTime: 0,
      // adjustment: '',
      // weightInProduct: 100,
    },
    {
      materialId: 'CMAL3',
      exposureCalendar: [
        {
          date: {
            year: 2023,
            month: 1,
          },
          value: 340000,
        },
        {
          date: {
            year: 2023,
            month: 2,
          },
          value: 320000,
        },
        {
          date: {
            year: 2023,
            month: 3,
          },
          value: 360000,
        },
        {
          date: {
            year: 2023,
            month: 4,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 5,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 6,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 7,
          },
          value: 0,
        },
        {
          date: {
            year: 2023,
            month: 8,
          },
          value: 570000,
        },
        {
          date: {
            year: 2023,
            month: 9,
          },
          value: 910000,
        },
        {
          date: {
            year: 2023,
            month: 10,
          },
          value: 1100000,
        },
        {
          date: {
            year: 2023,
            month: 11,
          },
          value: 120000,
        },
        {
          date: {
            year: 2023,
            month: 12,
          },
          value: 1150000,
        },
        {
          date: {
            year: NaN,
            month: NaN,
          },
          value: 6870000,
        },
      ],
      // basePrice: 550,
      // supplyLeadTime: 0,
      // adjustment: '',
      // weightInProduct: 100,
    },
  ].map((item) => ({
    ...item,
    exposureCalendar: item.exposureCalendar.map((exposureData) => ({
      ...exposureData,
      value: exposureData.value / 100,
    })),
  })),
});

export const getColorsInventory = (accountId: string): IInventoryReportType[] => {
  return [
    {
      monthYear: { month: 7, year: 2023 },
      materialId: 'CSSCc1',
      accountId,
      unitType: 'Ton' as const,
      reportingTime: '8/23/2023',
      quantity: 29000,
    },
    {
      reportingTime: '11/1/2023',
      unitType: 'Ton' as const,
      monthYear: { year: 2023, month: 10 },
      accountId,
      quantity: 29700,
      materialId: 'BUSc1',
    },
    {
      reportingTime: '10/1/2023',
      materialId: 'BUSc1',
      unitType: 'Ton' as const,
      monthYear: { month: 9, year: 2023 },
      quantity: 29800,
      accountId,
    },
    {
      quantity: 120,
      monthYear: { year: 2023, month: 6 },
      accountId,
      materialId: 'CMCU3',
      unitType: 'Ton' as const,
      reportingTime: '7/1/2023',
    },
    {
      materialId: 'CRCc1',
      unitType: 'Ton' as const,
      quantity: 3120,
      accountId,
      reportingTime: '10/1/2023',
      monthYear: { month: 9, year: 2023 },
    },
    {
      unitType: 'Ton' as const,
      materialId: 'CSRRc1',
      reportingTime: '10/1/2023',
      monthYear: { month: 9, year: 2023 },
      accountId,
      quantity: 8000,
    },
    {
      monthYear: { year: 2023, month: 6 },
      accountId,
      unitType: 'Ton' as const,
      reportingTime: '7/6/2023',
      materialId: 'HRCc1',
      quantity: 17600,
    },
    {
      accountId,
      reportingTime: '8/1/2023',
      unitType: 'Ton' as const,
      quantity: 260,
      monthYear: { year: 2023, month: 7 },
      materialId: 'CMZN3',
    },
    {
      unitType: 'Ton' as const,
      materialId: 'CSRRc1',
      reportingTime: '1/1/2023',
      monthYear: { year: 2023, month: 0 },
      quantity: 8500,
      accountId,
    },
    {
      accountId,
      monthYear: { month: 1, year: 2023 },
      unitType: 'Ton' as const,
      materialId: 'CSSCc1',
      quantity: 43000,
      reportingTime: '2/1/2023',
    },
    {
      unitType: 'Ton' as const,
      materialId: 'BUSc1',
      monthYear: { month: 5, year: 2023 },
      quantity: 28700,
      reportingTime: '6/1/2023',
      accountId,
    },
    {
      unitType: 'Ton' as const,
      materialId: 'CSRRc1',
      quantity: 8700,
      monthYear: { year: 2023, month: 2 },
      reportingTime: '3/1/2023',
      accountId,
    },
    {
      monthYear: { month: 7, year: 2023 },
      materialId: 'HRCc1',
      reportingTime: '8/1/2023',
      accountId,
      unitType: 'Ton' as const,
      quantity: 10000,
    },
    {
      reportingTime: '9/1/2023',
      monthYear: { month: 8, year: 2023 },
      quantity: 170,
      materialId: 'CMCU3',
      accountId,
      unitType: 'Ton' as const,
    },
    {
      reportingTime: '1/14/2023',
      quantity: 43000,
      monthYear: { month: 0, year: 2023 },
      accountId,
      materialId: 'CSSCc1',
      unitType: 'Ton' as const,
    },
    {
      quantity: 18900,
      unitType: 'Ton' as const,
      monthYear: { month: 4, year: 2023 },
      reportingTime: '5/5/2023',
      materialId: 'CSSCc1',
      accountId,
    },
    {
      monthYear: { year: 2023, month: 10 },
      accountId,
      materialId: 'CRCc1',
      unitType: 'Ton' as const,
      quantity: 2700,
      reportingTime: '11/1/2023',
    },
    {
      quantity: 26000,
      accountId,
      unitType: 'Ton' as const,
      materialId: 'BUSc1',
      reportingTime: '2/1/2023',
      monthYear: { year: 2023, month: 1 },
    },
    {
      quantity: 9700,
      reportingTime: '7/1/2023',
      accountId,
      monthYear: { year: 2023, month: 6 },
      materialId: 'CSRRc1',
      unitType: 'Ton' as const,
    },
    {
      unitType: 'Ton' as const,
      monthYear: { year: 2023, month: 1 },
      accountId,
      materialId: 'CSRRc1',
      quantity: 4700,
      reportingTime: '2/2/2023',
    },
    {
      accountId,
      quantity: 27000,
      unitType: 'Ton' as const,
      reportingTime: '2/2/2023',
      monthYear: { year: 2023, month: 1 },
      materialId: 'CSSCc1',
    },
    {
      reportingTime: '12/1/2023',
      accountId,
      monthYear: { month: 11, year: 2023 },
      quantity: 2450,
      unitType: 'Ton' as const,
      materialId: 'CRCc1',
    },
    {
      quantity: 7600,
      accountId,
      reportingTime: '8/15/2023',
      materialId: 'CSRRc1',
      monthYear: { year: 2023, month: 7 },
      unitType: 'Ton' as const,
    },
    {
      unitType: 'Ton' as const,
      reportingTime: '8/1/2023',
      materialId: 'BUSc1',
      accountId,
      monthYear: { year: 2023, month: 7 },
      quantity: 30000,
    },
    {
      accountId,
      materialId: 'CRCc1',
      monthYear: { month: 11, year: 2023 },
      unitType: 'Ton' as const,
      reportingTime: '12/1/2023',
      quantity: 3000,
    },
    {
      unitType: 'Ton' as const,
      reportingTime: '11/1/2023',
      quantity: 166,
      monthYear: { month: 10, year: 2023 },
      materialId: 'CMCU3',
      accountId,
    },
    {
      unitType: 'Ton' as const,
      reportingTime: '11/1/2023',
      monthYear: { year: 2023, month: 10 },
      materialId: 'CMZN3',
      accountId,
      quantity: 370,
    },
    {
      unitType: 'Ton' as const,
      monthYear: { year: 2023, month: 4 },
      reportingTime: '5/19/2023',
      quantity: 41000,
      accountId,
      materialId: 'CSSCc1',
    },
    {
      unitType: 'Ton' as const,
      quantity: 15000,
      monthYear: { year: 2023, month: 8 },
      accountId,
      materialId: 'HRCc1',
      reportingTime: '9/1/2023',
    },
    {
      quantity: 7600,
      materialId: 'CSRRc1',
      accountId,
      reportingTime: '4/1/2023',
      unitType: 'Ton' as const,
      monthYear: { year: 2023, month: 3 },
    },
    {
      monthYear: { year: 2023, month: 9 },
      materialId: 'CRCc1',
      accountId,
      reportingTime: '10/1/2023',
      unitType: 'Ton' as const,
      quantity: 1000,
    },
    {
      quantity: 24000,
      reportingTime: '7/18/2023',
      unitType: 'Ton' as const,
      accountId,
      monthYear: { month: 6, year: 2023 },
      materialId: 'BUSc1',
    },
    {
      accountId,
      unitType: 'Ton' as const,
      monthYear: { year: 2023, month: 6 },
      materialId: 'CMCU3',
      reportingTime: '7/1/2023',
      quantity: 140,
    },
    {
      unitType: 'Ton' as const,
      materialId: 'CSSCc1',
      quantity: 32000,
      reportingTime: '6/7/2023',
      accountId,
      monthYear: { year: 2023, month: 5 },
    },
    {
      reportingTime: '5/1/2023',
      unitType: 'Ton' as const,
      monthYear: { year: 2023, month: 4 },
      quantity: 370,
      accountId,
      materialId: 'CMZN3',
    },
    {
      materialId: 'CSSCc1',
      unitType: 'Ton' as const,
      monthYear: { year: 2023, month: 10 },
      reportingTime: '11/20/2023',
      accountId,
      quantity: 20000,
    },
    {
      monthYear: { year: 2023, month: 9 },
      accountId,
      materialId: 'HRCc1',
      unitType: 'Ton' as const,
      reportingTime: '10/1/2023',
      quantity: 21000,
    },
  ].map((a) => ({
    ...a,
    reportingTime: Timestamp.fromDate(new Date(a.reportingTime)),
    status: 'completed',
    fileUrl: '',
  }));
};

export const mockProducts: Product[] = [
  {
    id: 'Srp1',
    uuid: 'Srp1',
    name: 'Std. ERW pipe',
    ingredients: [{ materialID: 'HRCc1', weightInProduct: 1 }],
    category: 'Building',
    subCategory: 'Industrial',
    filesUrl: [],
    measureType: 'Ton',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-1',
    name: 'Product 1',
    ingredients: [
      { materialID: 'CSSCc1', weightInProduct: 76.34, percentInProduct: 45.12 },
      { materialID: 'CMAL3', weightInProduct: 52.85, percentInProduct: 23.47 },
    ],
    category: 'Building',
    subCategory: 'Industrial',
    filesUrl: [],
    measureType: 'Ton',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-2',
    name: 'Product 2',
    ingredients: [
      { materialID: 'CSRRc1', weightInProduct: 34.12, percentInProduct: 18.67 },
      { materialID: 'CMCU3', weightInProduct: 78.34, percentInProduct: 41.23 },
    ],
    category: 'Mechanics',
    subCategory: 'Aircraft',
    filesUrl: [],
    measureType: 'Unit',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-3',
    name: 'Product 3',
    ingredients: [
      { materialID: 'CMAL3', weightInProduct: 67.34, percentInProduct: 34.56 },
      { materialID: 'CMZN3', weightInProduct: 45.67, percentInProduct: 23.45 },
    ],
    category: 'Plumbing',
    subCategory: 'Pipes',
    filesUrl: [],
    measureType: 'Meter',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-4',
    name: 'Product 4',
    ingredients: [
      { materialID: 'BUSc1', weightInProduct: 56.78, percentInProduct: 27.89 },
      { materialID: 'CSSCc1', weightInProduct: 34.56, percentInProduct: 18.34 },
    ],
    category: 'HVAC',
    subCategory: 'Heating',
    filesUrl: [],
    measureType: 'Ton',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-5',
    name: 'Product 5',
    ingredients: [{ materialID: 'CMCU3', weightInProduct: 23.45, percentInProduct: 12.34 }],
    category: 'Electronics',
    subCategory: 'Circuit Boards',
    filesUrl: [],
    measureType: 'Unit',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-6',
    name: 'Product 6',
    ingredients: [
      { materialID: 'CMZN3', weightInProduct: 78.34, percentInProduct: 41.23 },
      { materialID: 'HRCc1', weightInProduct: 56.78, percentInProduct: 29.45 },
    ],
    category: 'Automotive',
    subCategory: 'Engine Parts',
    filesUrl: [],
    measureType: 'Meter',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-7',
    name: 'Product 7',
    ingredients: [
      { materialID: 'CSRRc1', weightInProduct: 45.67, percentInProduct: 23.45 },
      { materialID: 'CMAL3', weightInProduct: 34.56, percentInProduct: 18.34 },
    ],
    category: 'Furniture',
    subCategory: 'Chairs',
    filesUrl: [],
    measureType: 'Ton',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-8',
    name: 'Product 8',
    ingredients: [
      { materialID: 'BUSc1', weightInProduct: 67.89, percentInProduct: 34.56 },
      { materialID: 'CSSCc1', weightInProduct: 45.67, percentInProduct: 23.45 },
    ],
    category: 'Textiles',
    subCategory: 'Fabrics',
    filesUrl: [],
    measureType: 'Unit',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-9',
    name: 'Product 9',
    ingredients: [
      { materialID: 'CMCU3', weightInProduct: 78.34, percentInProduct: 41.23 },
      { materialID: 'CSRRc1', weightInProduct: 56.78, percentInProduct: 29.45 },
    ],
    category: 'Agriculture',
    subCategory: 'Machinery',
    filesUrl: [],
    measureType: 'Meter',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-10',
    name: 'Product 10',
    ingredients: [
      { materialID: 'CMAL3', weightInProduct: 34.56, percentInProduct: 18.34 },
      { materialID: 'CSSCc1', weightInProduct: 67.89, percentInProduct: 34.56 },
    ],
    category: 'Chemicals',
    subCategory: 'Cleaning Agents',
    filesUrl: [],
    measureType: 'Ton',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-11',
    name: 'Product 11',
    ingredients: [
      { materialID: 'CMZN3', weightInProduct: 78.34, percentInProduct: 41.23 },
      { materialID: 'BUSc1', weightInProduct: 56.78, percentInProduct: 29.45 },
    ],
    category: 'Metallurgy',
    subCategory: 'Steel',
    filesUrl: [],
    measureType: 'Unit',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
  {
    id: 'product-12',
    name: 'Product 12',
    ingredients: [
      { materialID: 'CSRRc1', weightInProduct: 67.89, percentInProduct: 34.56 },
      { materialID: 'CMAL3', weightInProduct: 45.67, percentInProduct: 23.45 },
    ],
    category: 'Mining',
    subCategory: 'Coal',
    filesUrl: [],
    measureType: 'Meter',
    priceHistory: [],
    status: 'completed',
    updatedAt: Timestamp.now(),
  },
];
